import {DataTableColumn} from "mantine-datatable";
import {MeteringRecord} from "../types.ts";
import {I18n} from "@aws-amplify/core";
import {StatusBadge} from "../profile/StatusBadge.tsx";
import {formatTimestamp} from "../../../utils/TableTimestamps.tsx";

export const useTableColumns = () => {

    const columns: DataTableColumn<MeteringRecord>[] = [
        {
            accessor: 'customerId',
            title: I18n.get('Customer'),
            width: '1fr',
            render: (item: MeteringRecord) => item.customerId,
        },
        {
            accessor: 'meterCode',
            title: I18n.get('Meter'),
            width: '1fr',
            render: (item: MeteringRecord) => item.meterCode ?? '-',
        },
        {
            accessor: 'periodStart',
            title: I18n.get('Period Start'),
            width: '1fr',
            render: (item: MeteringRecord) => item.periodStart ? formatTimestamp(item.periodStart) : '-',
        },
        {
            accessor: 'periodEnd',
            title: I18n.get('Period End'),
            width: '1fr',
            render: (item: MeteringRecord) => item.periodEnd ? formatTimestamp(item.periodEnd) : '-',
        },
        {
            accessor: 'value',
            title: I18n.get('Value'),
            width: '1fr',
            render: (item: MeteringRecord) => typeof item.value === 'number' ? String(item.value) : '-',
        },
        {
            accessor: 'state',
            title: I18n.get('State'),
            width: '1fr',
            render: (item: MeteringRecord) => <StatusBadge status={item.state}/>,
        },
        {
            accessor: 'updated',
            title: I18n.get('Updated'),
            width: '1fr',
            render: (item: MeteringRecord) => item.updated ? formatTimestamp(item.updated) : '-',
        },
    ];

    return {
        columns,
    }
}
